<title>{{ iagPortalSupportPage.htmlTitle }}</title>
<div class="container">
  <app-section [sections]="iagPortalSupportPage.sectionsJustAboveTable" [isIAGPortalDocumentationPage]="true"></app-section>
  <app-table-section [tableSections]="iagPortalSupportPage.tableSections"></app-table-section>
  <app-section [sections]="iagPortalSupportPage.sectionsJustBelowTable" [isIAGPortalDocumentationPage]="true"></app-section>
</div>
